@if (trendBarData) {
  <div class="gadget download-hide">
    <div class="main-header pl-2 mb-3 fw-bold" translate>{{title}}</div>
    <div class="d-flex flex-row trendBar">
      @for (data of entryKeys; track data) {
        <div class="col col-sm py-3 px-4">
          @if (trendBarData[data.entry_key] && (trendBarData[data.entry_key][filters.value] || trendBarData[data.entry_key]['prev_' + filters.value] ) ; ) {
            <div >
              <span class="title fw-bold">{{data.title}}</span>
              <div class="d-flex flex-wrap justify-content-between pt-4 pb-2">
                <div class="total align-self-start">{{trendBarData[data.entry_key][filters.value] ? (trendBarData[data.entry_key][filters.value][0].total || 0) : 0}}</div>
                @if (percent[data.entry_key]) {
                  <div class="percent align-self-end">
                    <i [ngClass]="{'d-none': percent[data.entry_key] > 0 }" class="fas fa-arrow-down" style="color:#FF3574"></i>
                    <i [ngClass]="{'d-none': percent[data.entry_key] < 0 }" class="fas fa-arrow-up" style="color:#00CA8A"></i>
                    {{percent[data.entry_key]}}%
                  </div>
                }
              </div>
            </div>
          }
          @if (!(trendBarData[data.entry_key] && (trendBarData[data.entry_key][filters.value] || trendBarData[data.entry_key]['prev_' + filters.value])); ) {
            <div >
              <span class="title fw-bold">{{data.title}}</span>
              <div class="text-center mt-1">
                <a [attr.href]="data.emptyLink"><img width="50" [src]="data.emptyImagePath"/></a>
              </div>
              <div class="text-center mt-2 more-info">
                @if (!moreInfoUrl) {
                  <a (click)="scrollTo(moreInfoFragment)" class="btn py-1 px-3" translate>More Info</a>
                }
                @if (moreInfoUrl) {
                  <a [routerLink]="moreInfoUrl" [fragment]="moreInfoFragment" class="btn py-1 px-3" translate>More Info</a>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
    @if (trendBarData && percent.length) {
      <div class="mt-1" translate>* From Previous Period</div>
    }
  </div>
} @else {
  <contentloader></contentloader>
}

